import { Text, View } from '@components/primitives';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import VersionCheck from 'react-native-version-check-expo';

function ProfileAppVersion(): JSX.Element {
  const currentAppVersion: string = VersionCheck.getCurrentVersion();
  const { t } = useTranslation('common');

  return (
    <View flexDirection="row" justifyContent="center" marginTop="16px" marginBottom="8px">
      <Text testID="txtAppVersion" variant="xsm-bold" color={colors.neutral.darkMist}>
        {t('profile.appVersion')}:{currentAppVersion}{' '}
      </Text>
    </View>
  );
}

export default ProfileAppVersion;
